import { Grid } from '@material-ui/core';
import React from 'react';
import { DefaultValues, SubmitHandler, useForm } from 'react-hook-form';
import {
  ControlledDatePicker,
  ControlledInput,
  ControlledSwitch,
  GridFormElement,
} from '../form-controls';
import { Study } from '../../api/studykit';
import { FormFooter } from '../styled/form-footer';

interface StudyFormProps {
  study?: DefaultValues<StudyFormFields>;
  onSubmit: SubmitHandler<StudyFormFields>;
  onCancel: () => void;
  submitButtonText?: string;
  cancelButtonText?: string;
}

export type StudyFormFields = Omit<Study, 'amountOfParticipants'>;

export const StudyForm: React.FC<StudyFormProps> = ({
  study,
  onSubmit,
  submitButtonText,
  onCancel,
  cancelButtonText,
}) => {
  const {
    handleSubmit,
    control,
    formState: { isSubmitting },
  } = useForm<StudyFormFields>({
    defaultValues: study,
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <GridFormElement label="Study Name">
          <ControlledInput
            control={control}
            name="name"
            rules={{ required: true }}
            inputProps={{ fullWidth: true, placeholder: 'Enter study name' }}
          />
        </GridFormElement>
        <GridFormElement label="Organization">
          <ControlledInput
            control={control}
            name="organization"
            rules={{ required: true }}
            inputProps={{ fullWidth: true, placeholder: 'Enter organization names' }}
          />
        </GridFormElement>
        <GridFormElement label="Start date">
          <ControlledDatePicker
            control={control}
            name="start"
            rules={{ required: true }}
            datePickerProps={{
              fullWidth: true,
              placeholder: 'Enter start date of the study',
            }}
          />
        </GridFormElement>
        <GridFormElement label="End date">
          <ControlledDatePicker
            control={control}
            name="end"
            rules={{ required: true }}
            datePickerProps={{ fullWidth: true, placeholder: 'Enter end date of the study' }}
          />
        </GridFormElement>
        <GridFormElement label="Blinded?">
          <ControlledSwitch name={'blinded'} control={control} />
        </GridFormElement>
      </Grid>
      <FormFooter
        isSubmitting={isSubmitting}
        onCancel={onCancel}
        cancelButtonText={cancelButtonText}
        submitButtonText={submitButtonText}
      />
    </form>
  );
};
